<template>
  <div id="app" class="flex-col">
    <!-- <div class="flex justify-between items-center h-20 px-10"> -->
    <headerBox />
    <!-- <slideMenu/> -->
    <!-- </div> -->
    <router-view class="flex items-center" style="min-height: calc(100vh - 10rem)" />
    <footerBox />
  </div>
</template>
<script src="https://kit.fontawesome.com/a739d1e087.js" crossorigin="anonymous"></script>

<script>
  import headerBox from '@/components/header.vue'
  import footerBox from '@/components/footer.vue'
  // import slideMenu from '@/components/slideMenu.vue'
  import {
    Hooper,
    Slide
  } from 'hooper';
  import 'hooper/dist/hooper.css';

  export default {
    components: {
      headerBox,
      footerBox,
      // slideMenu,
      Hooper,
      Slide
    }
  }
</script>

<style lang="scss">
  @import "../node_modules/bulma/bulma.sass";
  @import url('https://fonts.googleapis.com/css2?family=Kiwi+Maru:wght@300&family=Poppins&family=Sacramento&display=swap');

  #app {
    // font-family: 'Avenir', Helvetica, Arial, sans-serif;
    font-family: 'Poppins', 'Kiwi Maru';
    // font-family: 'Sacramento', cursive;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    min-height: 100vh;
    position: relative;
    padding-bottom: 10vh;
    // font-family:  'Comfortaa', 'M PLUS Rounded 1c', cursive;
  }

  #nav {
    padding: 30px;

    a {
      font-weight: bold;
      color: #2c3e50;

      &.router-link-exact-active {
        color: #42b983;
      }
    }
  }
</style>